"use client";
import { type FormEvent, useState } from "react";
import { Field } from "../../../components/fields";
import { Button, Page, Status, styles as s } from "../../../components/ui";
import { call } from "../../../lib/api-client";
import { lockText, useSubmit } from "../../../lib/use-submit";

export function PhoneChangeForm() {
  const [code, setCode] = useState("");
  const [birth, setBirth] = useState("");
  const [phone, setPhone] = useState("");
  const [sent, setSent] = useState(false);
  const f = useSubmit();
  const submit = (e: FormEvent) => {
    e.preventDefault();
    return f.run(async () => {
      const r = await call("POST", "/api/auth/phone/start", { customer_code: code, birthdate: birth, new_phone: phone });
      if (!r.ok) return f.setError(lockText(r.error));
      setSent(true);
    });
  };
  if (sent) {
    return (
      <Page title="ショートメールをご確認ください">
        <Status tone="ok">{phone} にショートメール（SMS）を送りました。メールのリンクを開いて、変更を仕上げてください。</Status>
        <p>変更が終わると、前の電話番号ではログインできなくなります。</p>
      </Page>
    );
  }
  return (
    <Page title="電話番号の変更" lead="機種変更などで電話番号が変わった方の手続きです。ご本人の確認のため、利用者コードと生年月日を入れてください。">
      {f.error && <Status tone="error">{f.error}</Status>}
      <form className={s.form} onSubmit={submit}>
        <Field label="利用者コード" inputMode="numeric" autoComplete="off" value={code} onChange={(e) => setCode(e.target.value)} required hint="ご請求書の右上に書かれた数字です。" />
        <Field label="生年月日（8けた）" inputMode="numeric" autoComplete="bday" maxLength={10} value={birth} onChange={(e) => setBirth(e.target.value)} required hint="例：1940年5月1日 生まれの方は 19400501" />
        <Field label="新しい電話番号（携帯電話）" type="tel" inputMode="tel" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        <Button type="submit" variant="primary" block disabled={f.busy}>確認のショートメールを送る</Button>
      </form>
    </Page>
  );
}
